import { io } from "socket.io-client";
import { baseURL } from "../config/index";
import secureLocalStorage from "react-secure-storage";

const socket = io(baseURL, {
    autoConnect: false,
    transports: ['websocket']
});

export const connectSocket = () => {
    if (!socket.connected) {
        const token = secureLocalStorage.getItem("token");
        if (token) {
            socket.auth = { token };
            socket.connect();
            console.log("Socket connecting with token...");
        } else {
            console.error("Cannot connect socket: No token found in secureLocalStorage");
        }
    }
};

export const disconnectSocket = () => {
    if (socket.connected) {
        socket.disconnect();
    }
};

export const joinTrackingRoom = (visitID) => {
    if (!visitID) return () => {};

    let isCancelled = false;
    const emitJoin = () => {
        if (isCancelled) return;
        console.log("Emitting join_visit_tracking for:", visitID);
        socket.emit("join_visit_tracking", visitID);
    };

    if (socket.connected) {
        emitJoin();
    } else {
        socket.once("connect", emitJoin);
        connectSocket();
    }

    return () => {
        isCancelled = true;
        socket.off("connect", emitJoin);
    };
};

export const leaveTrackingRoom = (visitID) => {
    socket.emit("leave_visit_tracking", visitID);
};

export const onLocationUpdate = (callback) => {
    // Listen for the broadcasted event from server
    socket.on("location_update", callback);
};

export const offLocationUpdate = () => {
    socket.off("location_update");
};

export const onStatusUpdate = (callback) => {
    socket.on("status_update", callback);
};

export const offStatusUpdate = () => {
    socket.off("status_update");
};

export default socket;
